/**
 * PrintService.js — Wrapper de compatibilidad para ZT-Bridge
 */

import printProvider from './printProvider';

export const isQzAvailable = () => false;

/**
 * API principal: imprime un pedido como ticket de cliente o cocina.
 */
export const printOrder = async (order, restaurantName = 'Conexo POS', _forceMethod = null, ticketType = 'customer') => {
  try {
    const result = await printProvider.printTicket(order, restaurantName, ticketType);
    return result;
  } catch (err) {
    console.error('[PrintService] Error en printOrder:', err);
    return { success: false, error: err.message };
  }
};

/**
 * Stub de conexión para compatibilidad con AdminPOS
 */
export const testLocalConnection = async () => {
  try {
    const res = await fetch('http://localhost:8001', { method: 'OPTIONS' });
    return res.ok;
  } catch (e) {
    return false;
  }
};

const PrintService = {
  isQzAvailable,
  printOrder,
  testLocalConnection,
  printKitchenTicket: (order) => printProvider.printKitchenTicket(order),
  printCustomerTicket: (order) => printProvider.printCustomerTicket(order),
  getPrinterServerUrl: () => printProvider.getPrinterServerUrl(),
  setPrinterServerUrl: (url) => printProvider.setPrinterServerUrl(url),
};

export default PrintService;
